import { jsx } from 'panel';
import { ToastEl } from 'common/components/toast';
export function template() {
  const {
    toasts
  } = this.state;
  return jsx("div", {
    sel: '.mp-toast-area'
  }, toasts.map(toast => jsx(ToastEl, {
    on: {
      action: () => this.helpers.toastAction(toast),
      close: () => this.helpers.toastClose(toast),
      undo: () => this.helpers.toastUndo(toast)
    },
    attrs: {
      cta: toast.cta || "",
      elref: toast.elref || "toast".concat(toast.id),
      hide: toast.hide,
      'hide-cancel-button': toast.hideCancelButton,
      'is-error': toast.isError,
      undoable: toast.undoable,
      timeout: toast.isStatic ? null : toast.timeout,
      type: toast.type
    }
  }, toast.message)));
}